export function is24hrEligibleSubProduct(subProduct) {
    if (!subProduct) {
        return false;
    }
    const flag = subProduct.is_24hr_eligible;
    return flag === true || flag === 1 || flag === "1";
}

export function is24HourMainProduct(product) {
    if (!product) {
        return false;
    }
    return (
        product.t_shirt_24_hour === true ||
        product.t_shirt_24_hour === 1 ||
        product.t_shirt_24_hour === "1"
    );
}

/** Explicit boolean for decoration JSON at add-to-cart (24-hour PDP vs normal). */
export function decorationTShirt24HourFlag(is24HourContext) {
    return (
        is24HourContext === true ||
        is24HourContext === 1 ||
        is24HourContext === "1" ||
        is24HourContext === "true"
    );
}

export function parseItemDecorationJson(item) {
    if (!item || item.decoration == null) {
        return null;
    }
    let decoration = item.decoration;
    if (typeof decoration === "string") {
        try {
            decoration = JSON.parse(decoration);
        } catch (e) {
            return null;
        }
    }
    return decoration && typeof decoration === "object" ? decoration : null;
}

/** Cart/order line: prefer decoration JSON t_shirt_24_hour; fallback to line column. */
export function isTShirt24HourFromItem(item) {
    const decoration = parseItemDecorationJson(item);
    if (
        decoration &&
        Object.prototype.hasOwnProperty.call(decoration, "t_shirt_24_hour")
    ) {
        return decorationTShirt24HourFlag(decoration.t_shirt_24_hour);
    }
    return decorationTShirt24HourFlag(item && item.t_shirt_24_hour);
}

export function resolveIs24HourPdpContext(route) {
    if (!route) {
        return false;
    }
    if (route.name === "24hoursTShirts") {
        return true;
    }
    const flag = route.query && route.query.is24hr;
    return flag === true || flag === "true" || flag === 1 || flag === "1";
}

export function serviceHasRush1Day(service, product) {
    if (!service || !product || !product.decorations) {
        return false;
    }
    try {
        let decorations = product.decorations;
        if (typeof decorations === "string") {
            decorations = JSON.parse(decorations);
        }
        if (
            !decorations ||
            !decorations.length ||
            !decorations[0].decoration_type_list
        ) {
            return false;
        }
        const entry = decorations[0].decoration_type_list.find(
            (item) => item.id === service.id
        );
        if (!entry) {
            return false;
        }
        return entry.rush1 === true || entry.rush1 === 1;
    } catch (e) {
        return false;
    }
}
